import { render, staticRenderFns } from "./gsjggl.vue?vue&type=template&id=5f6f722e"
import script from "./gsjggl.vue?vue&type=script&lang=js"
export * from "./gsjggl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports